import { render, staticRenderFns } from "./Design4.vue?vue&type=template&id=66b00ced&"
import script from "./Design4.vue?vue&type=script&lang=js&"
export * from "./Design4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports